
export default function TeamSection() {
  const team = [
    {
      name: 'João Paulo Avelino Perez',
      role: 'Diretor de Operações',
      description: 'Engenheiro Mecatrônico, Técnico em Mecatrônica, Engenheiro de Manutenção, especialista em Automação e Elétrica.',
      image: 'https://public.readdy.ai/ai/img_res/992d54a7193b54539a7e00d70fad1ab2.jpg'
    },
    {
      name: 'Monick Avelino Perez',
      role: 'Diretora Comercial',
      description: 'Engenheira Civil, Arquiteta e Urbanista, Técnica em Informática, Pós-graduada em Formação de Professores.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20architect%20and%20engineer%20in%20business%20attire%2C%20confident%20pose%2C%20modern%20office%20background%2C%20sophisticated%20lighting%2C%20executive%20portrait%2C%20clean%20background%2C%20professional%20headshot%2C%20architectural%20expertise%2C%20leadership%20presence&width=400&height=500&seq=monick&orientation=portrait'
    }
  ];

  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#3F3F3F] mb-4">
            Direção Técnica e Comercial
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {team.map((member, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="aspect-w-4 aspect-h-5">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#3F3F3F] mb-2">
                  {member.name}
                </h3>
                <p className="text-[#5C1A24] font-semibold mb-4">
                  {member.role}
                </p>
                <p className="text-sm text-[#3F3F3F] leading-relaxed">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}